import axios from 'axios';

export const getMyWebinarTicketsAsync = async () => {
  const { data } = await axios.get(`/webinars/tickets/paid`);

  return data;
};
